import { render, staticRenderFns } from "./Outcomes.vue?vue&type=template&id=281c0fc8&scoped=true&"
import script from "./Outcomes.vue?vue&type=script&lang=js&"
export * from "./Outcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c0fc8",
  null
  
)

export default component.exports